<template>
  <layout-default-dialog-appbar :back-to="manutencaoFrota" withDialog>
    Cadastro Manutenção Frota
  </layout-default-dialog-appbar>
</template>

<script>
import LayoutDefaultDialogAppbar from '@/layouts/default/DialogAppBar.vue';

import { ROUTE_MANUTENCAO_FROTA } from '@/constants/ROUTES';
import { ROTA_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'ViewFrotaAppBar',

  components: {
    LayoutDefaultDialogAppbar,
  },

  data() {
    return {
      manutencaoFrota: ROUTE_MANUTENCAO_FROTA,
    };
  },

  created() {
    sessionStorage.setItem(ROTA_STORAGE.cadastro, 'manutencao');
  },
};
</script>
